// extracted by mini-css-extract-plugin
export default {"wrapper":"Timer_wrapper__pPbVx","divider":"Timer_divider__KMtto","fadein":"Timer_fadein__m5KVO"};